export default __webpack_public_path__ + "static/media/MODE_compare.d4253106.svg";